var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.412,
    height: 12.091,
    viewBox: "0 0 20.412 12.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KYC_Details",
    "data-name": "KYC Details",
    transform: "translate(-159.099 -247.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M176.41,247.66H162.222a3.132,3.132,0,0,0-3.123,3.123v5.845a3.132,3.132,0,0,0,3.123,3.123h14.166a3.132,3.132,0,0,0,3.123-3.123v-5.845a3.1,3.1,0,0,0-3.1-3.123Zm-14.188,11.2a2.237,2.237,0,0,1-2.231-2.231v-5.845a2.237,2.237,0,0,1,2.231-2.231h3.926a6.029,6.029,0,0,0,0,10.307Zm7.094-10.306a5.153,5.153,0,1,1-5.153,5.153,5.17,5.17,0,0,1,5.153-5.153Zm9.325,8.075a2.237,2.237,0,0,1-2.231,2.231h-3.926a6.029,6.029,0,0,0,0-10.307h3.926a2.237,2.237,0,0,1,2.231,2.231Z",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M326.112,312.058H323.9l3.413,3.971.58-.669L325.844,313h.29a1.7,1.7,0,0,0,1.562-1.428h1.048v-.915H327.7a3.444,3.444,0,0,0-.178-.513h1.227v-.915h-4.417v.915h1.762a.841.841,0,0,1,.736.513h-2.5v.915h2.5a.825.825,0,0,1-.714.491Z",
    transform: "translate(-157.041 -58.665)",
    fill: "#ff7200"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.6e397ccce8e95adcae9f00965eb306c9.svg";
export { ForwardRef as ReactComponent };